import { usePlayer } from "../context/PlayerContext";
import { Avatar } from "./common";
import { Play, Pause, SkipBack, SkipForward, Shuffle, Repeat, Volume2, ChevronUp, X, ListMusic } from "lucide-react";
import { Link } from "react-router-dom";

function fmt(t) {
  if (!t || isNaN(t)) return "0:00";
  const m = Math.floor(t / 60), s = Math.floor(t % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
}

export function GlobalPlayer() {
  const p = usePlayer();
  if (!p.current) return null;
  const t = p.current;
  const pct = p.duration ? (p.progress / p.duration) * 100 : 0;

  return (
    <>
      {/* Expanded full player */}
      {p.expanded && (
        <div className="fixed inset-0 z-[60] bg-[#030303]/95 backdrop-blur-xl flex flex-col animate-rise" data-testid="player-expanded">
          <div className="flex justify-between items-center p-4">
            <span className="text-xs uppercase tracking-widest text-muted-foreground">Now Playing</span>
            <button onClick={() => p.setExpanded(false)} data-testid="player-collapse-btn" className="p-2 hover:text-eblue"><X size={22} /></button>
          </div>
          <div className="flex-1 flex flex-col items-center justify-center px-8 gap-6">
            <img src={t.cover_url} alt={t.title} className="w-64 h-64 md:w-80 md:h-80 rounded-2xl object-cover ring-glow" />
            <div className="text-center">
              <div className="font-display font-bold text-2xl">{t.title}</div>
              <Link to={t.artist ? `/${t.artist.username}` : "#"} className="text-eblue">{t.artist?.display_name}</Link>
            </div>
            <div className="w-full max-w-xl">
              <input type="range" min={0} max={p.duration || 0} value={p.progress} onChange={(e) => p.seek(Number(e.target.value))}
                className="w-full accent-[var(--eblue)]" data-testid="player-seek-expanded" />
              <div className="flex justify-between text-xs text-muted-foreground font-mono"><span>{fmt(p.progress)}</span><span>{fmt(p.duration)}</span></div>
            </div>
            <div className="flex items-center gap-7">
              <button onClick={() => p.setShuffle(!p.shuffle)} className={p.shuffle ? "text-eblue" : "text-muted-foreground"}><Shuffle size={20} /></button>
              <button onClick={p.prev}><SkipBack size={26} /></button>
              <button onClick={p.toggle} className="w-16 h-16 rounded-full btn-gold flex items-center justify-center" data-testid="player-toggle-expanded">
                {p.playing ? <Pause size={28} /> : <Play size={28} className="ml-1" />}
              </button>
              <button onClick={p.next}><SkipForward size={26} /></button>
              <button onClick={() => p.setRepeat(!p.repeat)} className={p.repeat ? "text-eblue" : "text-muted-foreground"}><Repeat size={20} /></button>
            </div>
          </div>
        </div>
      )}

      {/* Mini bar */}
      <div className="fixed left-0 right-0 bottom-16 md:bottom-0 md:left-20 lg:left-64 z-40 glass border-t border-white/10" data-testid="global-player">
        <div className="h-1 w-full bg-white/5">
          <div className="h-full bg-gradient-to-r from-[var(--eblue)] to-[var(--gold)]" style={{ width: `${pct}%` }} />
        </div>
        <div className="flex items-center gap-3 px-3 md:px-5 h-16">
          <img src={t.cover_url} alt={t.title} className="w-11 h-11 rounded-lg object-cover cursor-pointer" onClick={() => p.setExpanded(true)} />
          <div className="min-w-0 flex-1 cursor-pointer" onClick={() => p.setExpanded(true)}>
            <div className="text-sm font-semibold truncate">{t.title}</div>
            <div className="text-xs text-muted-foreground truncate">{t.artist?.display_name}</div>
          </div>
          <button onClick={p.prev} className="hidden md:block text-muted-foreground hover:text-white"><SkipBack size={18} /></button>
          <button onClick={p.toggle} className="w-10 h-10 rounded-full bg-white text-black flex items-center justify-center" data-testid="player-toggle">
            {p.playing ? <Pause size={18} /> : <Play size={18} className="ml-0.5" />}
          </button>
          <button onClick={p.next} className="text-muted-foreground hover:text-white"><SkipForward size={18} /></button>
          <div className="hidden lg:flex items-center gap-2 w-28">
            <Volume2 size={16} className="text-muted-foreground" />
            <input type="range" min={0} max={1} step={0.01} value={p.volume} onChange={(e) => p.setVolume(Number(e.target.value))} className="w-full accent-[var(--eblue)]" />
          </div>
          <button onClick={() => p.setExpanded(true)} className="text-muted-foreground hover:text-eblue"><ChevronUp size={18} /></button>
        </div>
      </div>
    </>
  );
}
